import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import sampledialogcancel from "src/Assets/images/Add.png";
import deleteicon from "src/Assets/images/Delete.svg";
import API from "../../network";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import feedstyles from "src/Assets/css/home/feedpost.module.css";

function DeleteDialog(props) {
  // const deleteStatusData = useSelector((state) => state.followReducer.DeleteStatus)

  const {
    onClose,
    open,
    deletePost,
    deleteSayCount,
    deleteAnswersToAsksDialogPost,
    deleteAsksToBeAnsweredDialogPost,
    decreaseSayCount,
    fetchContributors,
  } = props;
  const handleClose = () => {
    onClose(false);
  };
  const dispatch = useDispatch();
  const onDeletePost = async (id) => {
    // if (document.getElementById(id).style.display = "block") {
    //     document.getElementById(id).style.display = "none"
    // }
    // else {
    //     document.getElementById(id).style.display = "block"

    // }
    // let messageid = `?messageID=${id}`
    // let deletePostId = `FeedDataDelete${id}`
    // dispatch(feedactions.fetchDeleteStatus(messageid))
    // API.deleteMessage(id, props.type);
    if (props.deleteMessage) {
      await props.deleteMessage(id, props.type, props.Parent_ID);
    }
    // props.setDeletePostId(deletePostId)
    // props.setDeletePost(true)
    // dispatch(feedactions.fetchFeedData('?startlimit=0'))
    onClose(false);
    deleteAnswersToAsksDialogPost && deleteAnswersToAsksDialogPost(id);
    deleteAsksToBeAnsweredDialogPost && deleteAsksToBeAnsweredDialogPost(id);
    // below functionality will not work here
    // deletePost(id)
    setTimeout(() => {
      fetchContributors && fetchContributors();
      dispatch(SignInActions.fetchloginUser());
    }, 1000);
  };
  // console.log(deleteStatusData)

  return (
    <Modal
      onClose={handleClose}
      open={open}
      aria-labelledby="delete-confirmation-title"
      aria-describedby="delete-confirmation-description"
      key={props.id}
      sx={{
        zIndex: 4000,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          outline: "none",
          boxShadow: 24,
          minWidth: 300,
        }}
      >
        <div className={feedstyles.sampledialogcountandcancel}>
          <p>
            <b>Delete Confirmation</b>
          </p>
          <a onClick={handleClose}>
            <img src={sampledialogcancel} />
          </a>
        </div>
        <div>
          <p>Are you sure you want to delete this {props.type}?</p>
          <button
            onClick={() => onDeletePost(props.id)}
            className={feedstyles.dialogdeletebutton}
          >
            Delete
          </button>
        </div>
      </Box>
    </Modal>
  );
}

DeleteDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function ReusuableDeleteDialogmodal(props) {
  const [open, setOpen] = useState(false);
  const [msgtype, setmsgtype] = useState("");
  const handleClickOpen = () => {
    setOpen(true);
    if (
      props.type === "OpenASK" ||
      props.type === "TrendingASK" ||
      props.type === "ASK" ||
      props.type === "A" ||
      props.type === "Open ASK"
    ) {
      // msgtype="Ask"
      setmsgtype("ASK");
    } else if (props.type === "OpenSAY" || props.type === "S") {
      // msgtype="Say"
      setmsgtype("SAY");
    } else if (props.type === "impupdate" || props.type === "I") {
      // msgtype="Update"
      setmsgtype("UPDATE");
    } else if (
      props.type === "hashTAG" ||
      props.type === "H" ||
      props.type === "X" ||
      props.type === "#TAG"
    ) {
      //    msgtype="Tag"
      setmsgtype("TAG");
    } else if (props.type === "P") {
      setmsgtype("Reply");
    } else if (props.type === "W") {
      setmsgtype("Answer");
    } else if (props.type === undefined) {
      if (props?.postParentId !== null && !isNaN(props?.postParentId)) {
        setmsgtype("Answer");
      } else {
        setmsgtype("SAY");
      }
    } else {
      setmsgtype(props.type);
      // msgtype=props.type
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        key={props.id}
        onClick={(e) => {
          if (e && e.stopPropagation) e.stopPropagation();
          handleClickOpen();
        }}
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          padding: "0.375rem 1.5rem", boxSizing: "border-box", whiteSpace: "nowrap"
        }}
      >
        <img src={deleteicon} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
        <span style={{ fontSize: 14, whiteSpace: "nowrap"  }}>
          {props?.label ? props?.label : "Delete"}
        </span>
      </div>
      <DeleteDialog
        open={open}
        onClose={handleClose}
        id={props.id}
        Parent_ID={props.Parent_ID}
        type={msgtype}
        deleteMessage={props.deleteMessage}
        deletePost={props.deletePost}
        deleteSayCount={props.deleteSayCount}
        deleteAnswersToAsksDialogPost={props.deleteAnswersToAsksDialogPost}
        deleteAsksToBeAnsweredDialogPost={
          props.deleteAsksToBeAnsweredDialogPost
        }
        decreaseSayCount={props.decreaseSayCount}
        fetchContributors={props.fetchContributors}
      />
    </>
  );
}
